import React, { useState } from "react";
import { useEffect } from "react";
import { BaseURL } from "../../../../../base/env";
import Header from "../../../Cart/Header/Header";
import styles from "./DetailModal.module.css";
import { useTranslation } from "react-i18next";

const DetailModal = (props) => {
  const { open, setOpen, data } = props;
  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setTimeout(
      () => {
        setShow(open);
      },
      open ? 100 : 500
    );
  }, [open]);

  if (!open && !show) {
    return null;
  }

  return (
    <div
      className={`${styles.DetailModal} ${
        open && show ? styles.Show : styles.Hide
      }`}
    >
      <Header
        url={"/profile"}
        label={t("detailmodel.order_details")}
        onClose={() => {
          setOpen(false);
        }}
      />

      <div className={styles.Content}>
        <div className={styles.Card}>
          <h3 className={styles.Title}>{t("detailmodel.order_details")}</h3>

          <div className={styles.Separator} />

          <div className={"w-full flex justify-between items-center mt-1"}>
            <span className={styles.Label}>{t("summary.order_date")}</span>

            <span className={styles.OrderDate}>{data.order_date}</span>
          </div>

          <div className={"w-full flex justify-between items-center mt-1"}>
            <span className={styles.Label}>Item price</span>
            <span className={styles.Label2}>
              <span className={`${styles.TopAlign} ${styles.Label}`}>OMR </span>
              <strong>{data.item_price}</strong>
            </span>
          </div>

          <div className={"w-full flex justify-between items-center mt-1"}>
            <span className={styles.Label}>Service fee</span>
            <span className={styles.Label2}>
              <span className={`${styles.TopAlign} ${styles.Label}`}>OMR </span>
              <strong>{data.service_fee}</strong>
            </span>
          </div>

          <div className={"w-full flex justify-between items-center mt-1"}>
            <span className={styles.Label}>Credit used</span>
            <span className={styles.Label2}>
              <span className={`${styles.TopAlign} ${styles.Label}`}>OMR </span>
              <strong>{data.credit_used}</strong>
            </span>
          </div>

          <div className={"w-full flex justify-between items-center mt-1"}>
            <span className={styles.Label}>discount</span>
            <strong className={styles.Label2}>{data.discount}</strong>
          </div>

          <div className={"w-full flex justify-between items-center mt-1"}>
            <strong className={styles.Label}>Paid amount</strong>
            <span className={styles.Label2}>
              <strong>
                <span className={`${styles.TopAlign} ${styles.Label}`}>
                  OMR{" "}
                </span>
                {data.credit_used}
              </strong>
            </span>
          </div>

          <h3 className={`${styles.Title} ${styles.MarTop}`}>Order Item</h3>
          <div className={styles.Separator} />

          <div className={"w-full flex justify-center items-center"}>
            <div className={styles.ImageContainer}>
              <img
                alt="product"
                src={BaseURL + data.image}
                className={styles.Image}
              />
            </div>
            <div className={styles.OrderItemContent}>
              <p className={styles.ProductName}>{data.name}</p>
              <p className={styles.ProductName}>Quantity: {data.quantity}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailModal;
